import { Component } from '@angular/core';
@Component({
	templateUrl: '../../../../../../assets/svg/priority.svg',
})
export class PriorityIconComponent {}
